/**
 * this module is used to store all common client app base configuration flags
 */

module.exports = {
	isServer: false,		// is this a server side config
	isClient: true,			// is this a client side config
	useFecClient: false,	// some preparation steps have to be done only if the fec-client will be used.
	fecClientConfig: {		// if useFecClient is true this config is used to bundle the slimmest possible fec client necessary for the actual project
		// TODO: nice idea but is this in use anywhere?
	},
	heartbeatConfig: {
		turnedOn: false, // heartbeat server-side-events may be used if granted.
		authenticatedClientsOnly: true, // trigger heartbeats only for authenticated clients. NOTE: this may be overwritten by the heartbeat itself.
	},
	routes: {
		api: '/~/api'
	},
	store: {
		name: 'ThisShouldBeOverwrittenByTheUseCaseConfigStore',
		maxAge: 2 * 60 * 60 * 1000,
		cookie: {
			policy: {
				acceptTrackingDefault: null,	// true => accepted, false => not accepted, null => not decided yet
				acceptTrackingByDefault: false	// this flag decides what to do until the user has decided if he wants to grant or deny tracking cookies
			}
		}
	},
	media: { // media configs children will not be merged.
		preloadImagesGranted: true, // should detectRendered functions preload an image before returning any result on fecClients?
	},
	environment: { // environment configs children will not be merged.
		defaultBreakPoint: 'l',
		minDeltaUpdate: 500, // do not update a clients environment more often than this number of milliseconds.
		minDeltaServerUpdate: 5000, // do not send a clients environment update more often than this number of milliseconds to the server.
		styles: [ // which styles are available
			'mobile',
			'desktop',
		],
		style: { // list of styles associated with a device and optional a breakpoint.
			phone: 'mobile',
			tablet: {
				xs: 	'mobile',
				s: 		'mobile',
				m: 		'mobile',
				l: 		'desktop',
				xl: 	'desktop',
				xxl: 	'desktop',
			},
			desktop: {
				xs: 'mobile',
				s: 'mobile',
				m: 'mobile',
				l: 'desktop',
				xl: 'desktop',
				xxl: 'desktop',
			}
		},
		// list of devices and their breakpoints (or just plain breakpoints) and their max window.width in pixel.
		// layouts.desktop.xs = 400 means if a desktop device with a window.width smaller than 400 the breakpoint xs is active.
		// NOTE: if the string.length of a key is greater than 3 it is considered a device and a breakpoint otherwise.
		layouts: {
			// device independent breakpoint variant. // TODO: this is a very old feature. maybe one would want to test it.
			// xs: 400,
			// s: 768,
			// m: 1024,
			// l: 1600,
			// xl: 1920,
			// xxl: 3840,
			phone: {
				xs: 400,
				s: 768,
				m: 1024,
				l: 1600,
				xl: 1920,
				xxl: 3840,
			},
			tablet: {
				xs: 400,
				s: 768,
				m: 1024,
				l: 1600,
				xl: 1920,
				xxl: 3840,
			},
			desktop: {
				xs: 400,
				s: 768,
				m: 1024,
				l: 1600,
				xl: 1920,
				xxl: 3840,
			}
		},
	},
	// stores language options for this container.
	// NOTE: this flags children will not be merged.
	// language.available.de-at in this file and language.available.en-gb in clientAppConfig of a project will lead to en-gb only!
	// this flag is replacing appConfig.defaultLangCode, appConfig.i18next and service.config.availableLangCodes.
	// @see MARK: FEC_CONTAINER_INFORMATION
	// MARK: FEC_LANGUAGE_CONFIG
	language: {
		// replacement of appConfig.defaultLangCode
		default: 'de-at',
		// replacement of service.config.availableLangCodes.
		// NOTE: the default flag (language.available.de-at.default) does not exist any longer since it can be applied via language.default.
		available: {
			// this langCode serves the clients session, i18next and some fec/api procedures like homepage selection.
			// i18next will initialize 'de' as well as 'de-at'.
			// @see MARK: FEC_TRANSLATION_MANAGER
			'de-at': {
				route: '/de', // which route to use when a client browses to '/' and its favourite language is de-at.
				icon: 'flag-icon flag-icon-at', // used for cms-flag-icons
			},
		},
		// since most of the i18next config gets handled by the translationManager now there are just a few options left to set for i18next.
		// NOTE: it is not recommended but entirely possible to use all options in here i18next has to offer.
		// @see MARK: FEC_TRANSLATION_MANAGER
		i18next: {
			ns: ['common', 'error', 'button'], // list of namespaces to support.
			defaultNS: 'common', // default namespace
			// debug: true, // should i18next be chatty on the console for debugging purposes?
		},
	},
	ninjaModules: {
		// <ninjaModuleName>: {
		// 	turnedOn: false,	// decides if the ninjaModule can be used within the cms at all. should be false here no matter what because otherwise it would be turned on in every fec by default!
		// 	db: {...}, 			// the db object will be filled via frontend-controller/server/resourceTemplates/generators/ninjaModules/<ninjaModuleName>.js and stores some definitions like primaryKeyNames, modelNames, etc.
		// 	entity: {			// settings for main ninja table (e.g., cms_news)
		// 		<optionalComponentNinjaCodeName>: { 			// settings for optional components identified via ninjaCodeName and ninjaType from the frontend-project.
		// 			turnedOn: true,								// should the support for this optional component be turned on or not?
		// 			autoCreate: true,							// should this component be created automatically or not?
		// 			createDirtyFields: {						// which default values should be used if this optional component get created?
		// 				<attribute>: <value>,
		// 				...
		// 			},
		// 			showComponentContentProperties: false, 		// since the parent of each componentInstance is a componentContent form: should it be displayed at all? this would be the form where actions, config, etc. would be displayed.
		// 		},
		// 		...
		// 	},
		// 	entityPart: {										// settings for part ninja table (e.g., cms_newsParts)
		// 		route: {										// settings for routes associated with the partNinjaTable.
		// 			turnedOn: true,
		// 			autoCreate: true,
		// 			createDirtyFields: {
		// 				<attribute>: <value>,
		// 			},
		// 			prewarmGranted: true,						// is it allowed to prewarm routes of this type?
		// 			sitemapGranted: true,						// is it allowed to generate sitemap entries for routes of this type?
		// 		},
		// 		<optionalComponentNinjaCodeName>: {
		// 			turnedOn: true,
		// 			autoCreate: true,
		// 			createDirtyFields: {
		// 				<attribute>: <value>,
		// 				...
		// 			},
		// 			showComponentContentProperties: false,
		// 		},
		// 		...
		// 	},
		// },

		news: {
			turnedOn: false,
			entity: {
				coreInformation: {
					turnedOn: true,
					autoCreate: true,
					createDirtyFields: {
						status: 'preview & active',
					},
					showComponentContentProperties: false,
				},
			},
			entityPart: {
				coreInformation: {
					turnedOn: true,
					autoCreate: true,
					createDirtyFields: {
						status: 'preview & active',
					},
					showComponentContentProperties: false,
				},
				route: {
					turnedOn: true,
					autoCreate: true,
					createDirtyFields: {
						status: 'preview & active',
					},
					prewarmGranted: true,
					sitemapGranted: true,
				},
			},
		},
		events: {
			turnedOn: false,
			entity: {
				participants: {
					turnedOn: true,
				},
				additionalInformation: {
					turnedOn: false,
					autoCreate: true,
					createDirtyFields: {
						status: 'preview & active',
					},
					showComponentContentProperties: false,
				},
			},
			entityPart: {
				coreInformation: {
					turnedOn: true,
					autoCreate: true,
					createDirtyFields: {
						status: 'preview & active',
					},
					showComponentContentProperties: false,
				},
				route: {
					turnedOn: true,
					autoCreate: true,
					createDirtyFields: {
						status: 'preview & active',
					},
					prewarmGranted: true,
					sitemapGranted: true,
				},
				additionalInformation: {
					turnedOn: false,
					autoCreate: true,
					createDirtyFields: {
						status: 'preview & active',
					},
					showComponentContentProperties: false,
				},
			},
		},
	},
	credentials: {
		reLoginAction: 'credentials.showReLogin', // which action should be performed if a re-login is necessary
	},
	momentConfig: {
		timeZone: 'Europe/Vienna', 	// utils.moment will use this timezone for each new moment object if no timezone has been specified.
		locale: 'de'				// utils.moment will use this locale for each new moment object if no locale has been specified.
	},
	cache: {
		reuseCachedHtml: true,				// should the previously rendered html (identified by routes) be reused or not (in case of real apps using privileges and online periods caching must not be enabled)
		storeBuildMemoryPermanently: true, 	// should the buildMemory (trees, mappings, ...) be permanently stored within the componentTree instance or be deleted directly after the response has been sent?
		grantCacheByETag: false,			// should the fec client be allowed to cache requests based on etag?
	},
	requestIDFallback: 'client',
	sessionIDFallback: 'client',
	serviceDomainFallback: 'client',
	error: {
		handleClientError: true
	},
	debug: {
		fallbackConsole: false,
		componentListDebugging: false,
		checkForMultipleComponentOccurrences: false,
		injectComponentInstanceID: false,
	},
	defaultTimeZone: 		'Europe/Vienna',
	defaultMomentLocale: 	'de',

	timeMeasurement: false,
	statusControllerActionHandling: false,
	validator: {
		defaultLocale: 'de-DE',
		defaultIPVersion: 4,
		defaultISBNVersion: 13,
		defaultUUIDVersion: 4
	},
	useIDSelector: false, // use id as selectors for components (results in significant client side sizzle speedup for apps like the cms)
	inject: {
		selectors: true,			// should the component-data-index or id be injected
		componentClasses: true,		// should the component class be injected as css-class
		loadingClass: true,			// should the "loading"-class be injected as css-class (used for fec-clients only)
	    anchors: true,            	// inject html anchor tag for components to enable anchors based on componentInstanceID and componentName. this may only work if the component's config.anchorInjectionGranted=true grants the anchor usage.
	},
	// grants access to md-html file-transformations in /app/docs or not?
	// NOTE: overwrite completely in !
	// MARK: SEND_MD_DOCS
	docs: { // docs configs children will not be merged!
		authenticatedOnly: true,
		scopeRole: {
			scope: 'routeTree',
			option: 'showDocs',
		},
		// byDocument: { // one might list special rules by document
		// 	changeNotes: {
		// 		authenticatedOnly: true,
		// 		scopeRole: {
		// 			scope: 'routeTree',
		// 			option: 'showDocs',
		// 		},
		// 	},
		// },
	},

	envOverride: { // overrides original config based on NODE_ENV variable
		// development: {
		// 	useIDSelector: true,
		// },
	},
};
